// src/pages/ShopPage.jsx
import { FaDiscord, FaBell } from "react-icons/fa";

// Merch preview images
import JerseyBlack from "../assets/merch/pv-jersey-black.jpg";
import JerseyWhite from "../assets/merch/pv-jersey-white.jpg";
import JerseyBlackStripes from "../assets/merch/pv-jersey-black-stripes.jpg";
import TeamRed from "../assets/merch/Team-Red-Mockup.jpg";
import HatImg from "../assets/merch/pv-hats.jpg";
import RedHat from "../assets/merch/pv-red-hat.jpg";

const previewItems = [
  JerseyBlack,
  JerseyWhite,
  JerseyBlackStripes,
  TeamRed,
  HatImg,
  RedHat,
];

function ShopPage() {
  return (
    <main className="bg-black min-h-screen">
      {/* Hero */}
      <section className="relative py-24 px-6">
        <div className="absolute inset-0 bg-gradient-to-b from-red-900/20 to-black"></div>
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="inline-block bg-red-600 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded mb-6">
            Coming Soon
          </span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tight text-white mb-6">
            Prime Valor <span className="text-red-600">Shop</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-10">
            Official Prime Valor merch is on its way. Stay connected to be the first to know when the shop drops.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://discord.gg/SGXXCMpCxf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-bold uppercase tracking-wide rounded transition-colors"
            >
              <FaDiscord className="text-xl" />
              Get Notified on Discord
            </a>
          </div>
        </div>
      </section>

      {/* Merch Preview Grid */}
      <section className="px-6 pb-24">
        <div className="max-w-6xl mx-auto">
          <p className="text-center text-gray-500 text-sm uppercase tracking-widest mb-8">
            — Sneak Peek —
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {previewItems.map((img, i) => (
              <div
                key={i}
                className="relative aspect-square overflow-hidden rounded-lg group"
              >
                <img
                  src={img}
                  alt={`Merch preview ${i + 1}`}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/10 transition-all duration-500"></div>
                {/* Lock icon */}
                <div className="absolute inset-0 flex items-center justify-center opacity-60 group-hover:opacity-0 transition-opacity duration-300">
                  <FaBell className="text-white text-3xl" />
                </div>
              </div>
            ))}
          </div>
          <p className="text-center text-gray-600 text-sm mt-8">
            Hover to preview • Full collection dropping soon
          </p>
        </div>
      </section>
    </main>
  );
}

export default ShopPage;
